/**
 * File navigation.js.
 *
 * Handles toggling the navigation menu for small screens and enables TAB key
 * navigation support for dropdown menus.
 */
export default () => {
	(function ($) {
		var container, button, menu, links, i, len;

		var body = $('body');

		$('.bg-menu-mobile-bg').click(function () {
			$('body').removeClass('mmenu-open');
		});

		$('.menu-closer').click(function () {
			$('body').removeClass('mmenu-open');
		});


		$('.toggle-submenu-button').on('click', toggle_submenu);

		container = document.getElementById('site-navigation');
		if (!container) {
			return;
		}

		button = document.getElementById('menu-toggle');
		if ('undefined' === typeof button) {
			return;
		}

		menu = container.getElementsByTagName('ul')[0];

		menu.setAttribute('aria-expanded', 'false');
		if (-1 === menu.className.indexOf('nav-menu')) {
			menu.className += ' nav-menu';
		}

		button.onclick = function () {
			if (!body.hasClass('mmenu-open')) {
				body.addClass('mmenu-open');
				button.setAttribute('aria-expanded', 'false');
				menu.setAttribute('aria-expanded', 'false');
			} else {
				body.removeClass('mmenu-open');
				button.setAttribute('aria-expanded', 'true');
				menu.setAttribute('aria-expanded', 'true');
			}
		};

		// Get all the link elements within the menu.
		links = menu.getElementsByTagName('a');

		// Each time a menu link is focused or blurred, toggle focus.
		for (i = 0, len = links.length; i < len; i++) {
			links[i].addEventListener('focus', toggleFocus, true);
			links[i].addEventListener('blur', toggleFocus, true);
		}

		/**
		* Sets or removes .focus class on an element.
		*/
		function toggleFocus() {
			var self = this;

			// Move up through the ancestors of the current link until we hit .nav-menu.
			while (-1 === self.className.indexOf('nav-menu')) {

				// On li elements toggle the class .focus.
				if ('li' === self.tagName.toLowerCase()) {
					if (-1 !== self.className.indexOf('focus')) {
						self.className = self.className.replace(' focus', '');
					} else {
						self.className += ' focus';
					}
				}

				self = self.parentElement;
			}
		}

		function toggle_submenu(e) {
			e.preventDefault();
			e.stopPropagation();
			var toggle_char = ['<i class="fa-solid fa-chevron-down"></i>', '<i class="fa-solid fa-chevron-up"></i>'];
			$(this).toggleClass('toggled');
			$(this).parent().parent().children('.sub-menu').toggleClass('toggled');
			$(this).html(toggle_char[($(this).html() === toggle_char[0]) ? 1 : 0]);
		}


		let observer = new IntersectionObserver(entries => {
			if (entries[0].boundingClientRect.y < window.innerHeight) {
				document.body.classList.add('is-past-fold');
			} else {
				document.body.classList.remove('is-past-fold');
			}
		});
		observer.observe(document.querySelector("#fold-pixel"));

	})(jQuery);
}